import React from 'react';
import { string } from 'prop-types';
import { intlShape, FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import config from '../../../../config';
import { Divider } from '../../../../components';

import css from './Footer.module.css';

const Footer = (props) => {
  const {
    className,
    intl,
  } = props;
  const footerText = intl.formatMessage({ id: 'CalendarPage.SidePanel.footer' });
  const classes = classNames(css.root, className);

  return (
    <div className={`${classes} ${css.containerFooter}`}>
      <Divider className={css.divider} />
      <span className={css.text}>{footerText}</span>
      <a
        href={config.custom.openTicketLink}
        target="_blank"
        rel="noopener noreferrer"
        className={css.link}
      >
        <FormattedMessage id="SimulatorPage.contactMail"/>
      </a>
    </div>
  )
}

Footer.defaultProps = {
  className: null,
};

Footer.propTypes = {
  className: string,
  intl: intlShape.isRequired,
};

export default Footer;
